import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const LoadingIndicator = ({ showLoader, fallbackUi }) => {
  const [showFallbackUi, setShowFallbackUi] = useState(false);

  useEffect(() => {
    let timer = null;
    if (fallbackUi) {
      timer = setTimeout(() => setShowFallbackUi(true), 300);
    }
    return () => clearTimeout(timer);
  }, [fallbackUi]);

  const getClassIdentifier = () => {
    if (fallbackUi) {
      return showFallbackUi;
    }
    return showLoader;
  };

  return (
    <div
      className={`product-list__container-wrapper ${getClassIdentifier() ? 'active' : ''} ${
        fallbackUi ? 'fallback' : ''
      }`}
    >
      <div className="product-list__container-loader-wrapper">
        <div className="product-list__container-loader">
          <div className="product-list__container-loader--shadow" />
          <div className="product-list__container-loader--icon" />
        </div>
        <div className="product-list__container-msg">
          <div className="product-list__container-msg--data">
            <FormattedMessage
              id={`${fallbackUi ? 'loading.indicator.message' : 'products.productgrid.loading'}`}
              description="Spinner message"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

LoadingIndicator.propTypes = {
  showLoader: PropTypes.bool,
  fallbackUi: PropTypes.bool,
};
LoadingIndicator.defaultProps = {
  fallbackUi: false,
  showLoader: false,
};

export default LoadingIndicator;
